import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import OpenModalButton, {
  OpenModalButtonProps,
} from 'components/OpenModalButton';
import { MessageBundle, uiStageToBackendStage } from '@xbcb/ui-types';
import { getEnv, safeGetMessage } from '@xbcb/ui-utils';
import { useBundle } from '@amzn/react-arb-tools';
import { useCurrentUser } from 'libs/hooks';
import { PROJECT42_FEATURE, Project42Features } from '@xbcb/feature-flags';
import { capitalCase } from 'change-case';

const createRecordModalContent = (bundle: MessageBundle) => (
  <>
    <PlusOutlined /> {safeGetMessage(bundle, 'create')}
  </>
);

interface CreateButtonModalProps extends OpenModalButtonProps {
  modalContent?: React.ReactNode | JSX.Element;
}

export const CreateButtonModal: React.FC<CreateButtonModalProps> = ({
  modalContent,
  ...props
}) => {
  const [bundle] = useBundle('shared');
  const user = useCurrentUser();

  const isProject42MockDataEnabled =
    user.shipper?.id &&
    PROJECT42_FEATURE.isEnabled(Project42Features.PROJECT42_USE_MOCK_DATA, {
      stage: uiStageToBackendStage[getEnv().stage],
      shipper: user.shipper?.id,
    });

  const dynamicButtonStyle = isProject42MockDataEnabled
    ? { backgroundColor: '#780650', color: '#fff' }
    : undefined;

  const dynamicContent =
    modalContent ??
    (isProject42MockDataEnabled ? (
      <>
        <PlusOutlined /> {capitalCase(props.modalKey)}
      </>
    ) : (
      createRecordModalContent(bundle)
    ));

  return (
    <OpenModalButton
      key={`${props.modalKey}Button`}
      buttonStyle={dynamicButtonStyle}
      {...props}
    >
      {dynamicContent}
    </OpenModalButton>
  );
};

export default CreateButtonModal;
